<template>
  <div class="large-btn" :class="`${this.type}`" v-on="$listeners">
    <p class="p">
      <slot></slot>
    </p>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'success'
    }
  },
  data() {
    return {
    };
  },
  computed:{
    style(){
      return {
      }
    }
  },
  mounted(){
  },
  methods:{
  }
};
</script>
<style lang="less" scoped>
.large-btn{
  transition: .1s;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  padding: 15px 25px;  
  display: inline-block;
  text-align: center;
  margin: 10px;
  cursor: pointer;
  border-radius: 2px;
}
</style>
